import * as routing from "@baseline/ui/routing/legacy";
import { RoutePath } from "@baseline/ui/routing/legacy";

export type routes = typeof routes;

export const routes =
{
    landingPage: RoutePath.build("/transaction-session"),
    tokenizationPage: RoutePath.build("/tokenization-session"),
};
